import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createOrganizationsActionsSlice, createOrganizationsDataSlice } from './slices'
import type { OrganizationsStore } from './types'

export const useOrganizationsStore = create<OrganizationsStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createOrganizationsDataSlice(...args),
        ...createOrganizationsActionsSlice(...args),
      }))
    ),
    {
      name: 'OrganizationsSettingsStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
